<template>
  <div>
    <p-d-p-component />
    <p-l-p-component :categoryPath="categoryPath"/>
    <cart-component/>
    <checkout-component/>
    <order-confirmation-component/>
    <newsletter-component/>
  </div>
</template>

<script>

import PDPComponent from './components/PDPComponent';
import PLPComponent from './components/PLPComponent';
import CartComponent from './components/CartComponent';
import CheckoutComponent from './components/CheckoutComponent';
import OrderConfirmationComponent from './components/OrderConfirmationComponent'
import SiteMixins from "@global/mixins/SiteMixins";
import CONST from "@/utils/Constants";
import GAMixins from "@global/lptGoogleAnalytics/mixins/GAMixins";
import NewsletterComponent from "@global/lptGoogleAnalytics/components/NewsletterComponent.vue";

export default {
  name: "GoogleAnalytics",
  components: {
    NewsletterComponent,
    PDPComponent,
    PLPComponent,
    CartComponent,
    CheckoutComponent,
    OrderConfirmationComponent
  },
  mixins: [SiteMixins,GAMixins],
  data() {
    return {
      collectionMap: this.$parent.$options.collectionMap,
      urlEn: this.$parent.$options.urlEn,
      categoryPath: this.$parent.$options.categoryPath,
      user: ACC.config.user,
      url: window.location.href,
      flag: ACC.config.flagVistaDivision,
      GAEnabled: !this.isSiteCn(),
    }

  },
  methods: {
    getStatus() {
      if (this.user.company != null) {
        return 'logged_in'
      }
      return 'logged_not'
    },
    getCurrentUrl() {
      if (this.urlEn) {
        return location.origin + '/' + 'interiors' + this.urlEn;
      }
      return this.url
    },
  },
  created() {
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.SELECT_AREA, (flagClick) => {
      const entry = {
        'event': 'select_area',
        'reference_brand_destination': flagClick
      }
      this.pushEvent(entry);
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.LOG_IN, () => {
      const entry = {
        'event' : 'login'
      }
      this.pushEvent(entry);
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.ERROR, (message) => {
      const entry = {
        'event' : 'custom_error',
        'error_type': 'javascript_error',
        'error_message': message
      }
      this.pushEvent(entry);
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.SELECT_CONTENT, (entry) => {
      this.pushEvent(entry);
    });
  },


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/GoogleAnalytics.vue